import { __extends } from 'tslib';
import * as React from 'react';
import { UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-date-picker.css';

var getClassNameList = classNames.bind(styles);
var UitkDatePickerInput = /** @class */ (function (_super) {
    __extends(UitkDatePickerInput, _super);
    function UitkDatePickerInput() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UitkDatePickerInput.prototype.render = function () {
        var _a = this.props, cssClassNames = _a.cssClassNames, isDialog = _a.isDialog, onClick = _a.onClick, selection = _a.selection, selectionDateMsg = _a.selectionDateMsg, singleMode = _a.singleMode, selectionDate = _a.selectionDate;
        var selectionButtonClasses = getClassNameList(cssClassNames, {
            'selection-filled': selection,
            'uitk-date-picker-input': selection && !isDialog
        });
        var grow = isDialog && !singleMode ? 1 : undefined;
        return (React.createElement(UitkLayoutFlexItem, { grow: grow, className: selectionButtonClasses, minWidth: singleMode ? 'half_width' : undefined },
            React.createElement("button", { type: "button", onClick: onClick },
                React.createElement("span", { className: getClassNameList('uitk-date-picker-selection-date') },
                    selectionDate,
                    selectionDateMsg && React.createElement("span", { className: getClassNameList('is-visually-hidden') },
                        ": ",
                        selectionDateMsg)))));
    };
    UitkDatePickerInput.displayName = 'UitkDatePickerInput';
    return UitkDatePickerInput;
}(React.Component));
var UitkNewDatePickerInput = UitkDatePickerInput;

export { UitkDatePickerInput, UitkNewDatePickerInput };
